// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.student-detail h1 {
  margin-bottom: 1rem;
  color: #2c3e50;
}

.breadcrumb {
  margin-bottom: 1rem;
  color: #7f8c8d;
}

.breadcrumb a {
  color: #3498db;
  text-decoration: none;
}

.breadcrumb a:hover {
  text-decoration: underline;
}

.student-info {
  background: white;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 2rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.student-info p {
  margin: 0.5rem 0;
}

.progress-section {
  margin-top: 1.5rem;
}

.progress-section h3 {
  margin-bottom: 1rem;
  color: #2c3e50;
}

.no-access {
  color: #7f8c8d;
  font-style: italic;
}

.exercise-card {
  margin-bottom: 1rem;
}

.exercise-card-summary {
  cursor: pointer;
  list-style-position: inside;
}

.exercise-card-summary::-webkit-details-marker {
  color: #3498db;
}

.exercise-card-summary h2 {
  display: inline;
  margin-left: 0.5rem;
}

.exercise-card > :not(summary) {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}

.exercise-card > .progress-section {
  margin-top: 1.5rem;
}

.student-code-files {
  display: grid;
  gap: 0.75rem;
}

.student-code-file {
  border: 1px solid #d9e2ec;
  border-radius: 6px;
  overflow: hidden;
}

.student-code-file summary {
  cursor: pointer;
  padding: 0.65rem 0.85rem;
  background: #f4f7fa;
  font-weight: 600;
}

.student-code-file pre {
  margin: 0;
  padding: 1rem;
  overflow-x: auto;
  background: #1e293b;
  color: #e2e8f0;
  font-size: 0.85rem;
  line-height: 1.5;
  white-space: pre-wrap;
}

.code-last-saved {
  color: #64748b;
  font-size: 0.85rem;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/teacher/StudentDetail.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX","sourcesContent":[".student-detail h1 {\n  margin-bottom: 1rem;\n  color: #2c3e50;\n}\n\n.breadcrumb {\n  margin-bottom: 1rem;\n  color: #7f8c8d;\n}\n\n.breadcrumb a {\n  color: #3498db;\n  text-decoration: none;\n}\n\n.breadcrumb a:hover {\n  text-decoration: underline;\n}\n\n.student-info {\n  background: white;\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 2rem;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.student-info p {\n  margin: 0.5rem 0;\n}\n\n.progress-section {\n  margin-top: 1.5rem;\n}\n\n.progress-section h3 {\n  margin-bottom: 1rem;\n  color: #2c3e50;\n}\n\n.no-access {\n  color: #7f8c8d;\n  font-style: italic;\n}\n\n.exercise-card {\n  margin-bottom: 1rem;\n}\n\n.exercise-card-summary {\n  cursor: pointer;\n  list-style-position: inside;\n}\n\n.exercise-card-summary::-webkit-details-marker {\n  color: #3498db;\n}\n\n.exercise-card-summary h2 {\n  display: inline;\n  margin-left: 0.5rem;\n}\n\n.exercise-card > :not(summary) {\n  margin-left: 1.5rem;\n  margin-right: 1.5rem;\n}\n\n.exercise-card > .progress-section {\n  margin-top: 1.5rem;\n}\n\n.student-code-files {\n  display: grid;\n  gap: 0.75rem;\n}\n\n.student-code-file {\n  border: 1px solid #d9e2ec;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.student-code-file summary {\n  cursor: pointer;\n  padding: 0.65rem 0.85rem;\n  background: #f4f7fa;\n  font-weight: 600;\n}\n\n.student-code-file pre {\n  margin: 0;\n  padding: 1rem;\n  overflow-x: auto;\n  background: #1e293b;\n  color: #e2e8f0;\n  font-size: 0.85rem;\n  line-height: 1.5;\n  white-space: pre-wrap;\n}\n\n.code-last-saved {\n  color: #64748b;\n  font-size: 0.85rem;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
